'use strict'
var posts = angular.module('postsModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap',
	'thatisuday.dropzone',
	'diff-match-patch',
	'ngSanitize'
	
]);
require('./allposts/js/directive/allpostsDirective.js')(posts);
require('./allposts/js/allpostsController.js')(posts);
// require('./allposts/js/directive/categoryModalDirective.js')(posts);
require('./edit-newpost/js/directive/postDirective.js')(posts);
require('./edit-newpost/js/postController.js')(posts);
require('./edit-newpost/js/directive/tinymcePostController.js')(posts);
require('./edit-newpost/js/directive/setFeaturedImageDirective.js')(posts);
require('./edit-newpost/js/directive/editImageDirective.js')(posts);
require('./edit-newpost/js/directive/cropImageDirective.js')(posts);
require('./edit-newpost/js/directive/croppieDirective.js')(posts);
require('./edit-newpost/js/directive/addToDictionaryDirective.js')(posts);
require('./edit-newpost/js/directive/onScrollLoadDirective.js')(posts);
require('./edit-newpost/js/directive/recommendedNewsDirective.js')(posts);
require('./categories/js/directive/categoriesDirective.js')(posts);
require('./categories/js/categoriesController.js')(posts);
require('./tags/js/directive/tagsDirective.js')(posts);
require('./tags/js/tagsController.js')(posts);
require('./category-edit/js/directive/categoryEditDirective.js')(posts);
require('./category-edit/js/categoryEditController.js')(posts);
require('./tag-edit/js/directive/tagEditDirective.js')(posts);
require('./tag-edit/js/tagEditController.js')(posts);
require('./sortableImageGalleryDirective.js')(posts);
require('./sortableImageGalleryHorDirective')(posts);
require('./edit-newpost/js/directive/revisionsDirective.js')(posts);
require('./usElection/js/directive/usElectionDirective.js')(posts);
require('./usElection/js/usElectionController.js')(posts);



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/postsModule.js
// module id = 565
// module chunks = 0